import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { apiRequest, type ApiError } from './config'

// Flattened VoiceInfo matching backend
export interface VoiceInfo {
  id: string
  name?: string | null
  description?: string | null
  gender?: string | null
  previewUrl?: string | null
  language?: string | null  // Primary language code (e.g., "en", "de")
  isDefaultA: boolean
  isDefaultB: boolean
  category?: string
}

export const VOICE_QUERY_KEYS = {
  all: ['voices'] as const,
  byProvider: (provider?: string) => ['voices', provider] as const,
  byLanguage: (language?: string) => ['voices', 'lang', language] as const,
} as const

export const fetchVoices = async (provider?: string, language?: string): Promise<VoiceInfo[]> => {
  const params = new URLSearchParams()
  if (provider) params.append('provider', provider)
  if (language) params.append('language', language.toLowerCase())
  const suffix = params.toString() ? `?${params.toString()}` : ''
  return apiRequest<VoiceInfo[]>(`/api/voices${suffix}`)
}

export const useVoices = (provider?: string, language?: string): UseQueryResult<VoiceInfo[], ApiError> => {
  return useQuery({
    queryKey: language ? VOICE_QUERY_KEYS.byLanguage(language) : VOICE_QUERY_KEYS.byProvider(provider),
    queryFn: async (): Promise<VoiceInfo[]> => fetchVoices(provider, language),
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
    gcTime: 24 * 60 * 60 * 1000, // 24 hours
  })
}

// Single-voice endpoint removed from backend; keep only list API
